<template>
  <div class="publications-box">
    <h2 class="publications-box_title">Publications featuring this artist</h2>
    <div class="publications-box__tabs">
      <Tag
        v-for="(publication, key) in relatedPublications"
        :key="`${key}-publication-tab`"
        class="tag--public tag--default"
        :class="{ 'tag--selected': activeTab === key }"
        :value="publication.title"
        @click="activeTab = key"
      />
    </div>
    <div>
      <a
        v-for="(publication, key) in relatedPublications[activeTab]?.list"
        :key="`${key}-publication-item`"
        class="publications-box_item"
        :class="{ 'no-clickable': !publication.slug }"
        :href="publication.slug"
        target="_blank"
      >
        <span class="title">{{ publication.title }}</span>
        <span class="author">{{ publication.type }} by {{ publication.author }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Tag from "@/components/Tag.vue";
export default {
  components: { Tag },
  props: {
    relatedPublications: {
      type: Object | Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "all",
    };
  },
};
</script>

<style lang="scss" scoped>
.publications-box {
  display: flex;
  flex-direction: column;
  margin-top: 15rem;
  width: 70%;
  @media screen and (max-width: $md) {
    width: 100%;
  }
  @media screen and (max-width: $xs) {
    margin-top: 9.5rem;
  }
  @media screen and (max-width: $xs) {
    align-items: center;
  }
  &__tabs {
    display: flex;
    gap: 0 10px;
    margin-bottom: 30px;
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      gap: 0 8px;
    }
  }

  &_title {
    font-size: 4rem;
    line-height: 5rem;
    margin-bottom: 30px;
    @media screen and (max-width: $xs) {
      font-size: 3.5rem;
      line-height: 4.3rem;
    }
  }

  &_item {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    text-decoration: none;
    &.clickable {
      cursor: default;
    }

    .title {
      font-size: 2.4rem;
      line-height: 3.1rem;
    }
  }

  .button {
    margin-top: 1.3rem;
  }
}
</style>

